export default {
    notifications: [
    /* {
         id: "mock-1",
         title: "Nuova Banca Dati disponibile",
         body: "È stata pubblicata la banca dati ufficiale per il concorso INPS 2026. Inizia subito ad esercitarti!",
         timestamp: "2026-01-30T10:30:00.000Z",
         read: false,
         type: 3
      },
       {
         id: "mock-2",
         title: "Aggiornamento Quiz",
         body: "Abbiamo aggiunto 150 nuove spiegazioni ai quiz di Diritto Amministrativo.",
         timestamp: "2026-01-30T08:15:00.000Z",
         read: false
      },
      {
        id: "mock-3",
        title: "Promozione Premium",
        body: "Sblocca tutte le funzionalità senza limiti! Passa a Premium con lo sconto del 20%.",
        timestamp: "2026-01-29T17:45:00.000Z",
        read: false
   },
      {
        id: "mock-4",
        title: "Simulazione completata",
        body: "Complimenti! Hai completato la simulazione con un punteggio di 28.5/30. Controlla la tua posizione in graduatoria.",
        timestamp: "2026-01-28T14:20:00.000Z",
        read: false
      } */
    ]
};